import { render, staticRenderFns } from "./r-product-table.vue?vue&type=template&id=579d002c"
import script from "./r-product-table.vue?vue&type=script&lang=js"
export * from "./r-product-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579d002c')) {
      api.createRecord('579d002c', component.options)
    } else {
      api.reload('579d002c', component.options)
    }
    module.hot.accept("./r-product-table.vue?vue&type=template&id=579d002c", function () {
      api.rerender('579d002c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product/r-product-table.vue"
export default component.exports